package org.zest.insan_360_website.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.browser.api
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.dvh
import com.varabyte.kobweb.compose.css.dvw
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.window
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text
import org.zest.insan_360_website.components.layouts.containerShadowStyle
import org.zest.insan_360_website.components.layouts.userPageBorderStrongColor
import org.zest.insan_360_website.components.layouts.userPageColor
import kotlin.time.Duration.Companion.milliseconds

@Page("payment-status")
@Composable
fun PaymentStatusPage(ctx: PageContext) {
    val billCode = ctx.route.params["billcode"] ?: ""
    var transactionStatus by remember { mutableStateOf("PENDING") }

    if (billCode.isBlank()) {
        Div { Text("Missing financial tracking parameters.") }
        return
    }

    LaunchedEffect(Unit) {
        while (transactionStatus == "PENDING") {
            try {
                val statusBytes = window.api.getBytes("payment/status?bill_code=$billCode")
                val statusString = statusBytes.decodeToString()

                console.log("Polling Status: $statusString")
                transactionStatus = statusString
            } catch (e: Exception) {
                console.error("Polling error: ${e.message}")
            }

            if (transactionStatus == "PENDING") {
                delay(2000.milliseconds)
            }
        }
    }

    Box(
        Modifier
            .height(100.dvh)
            .width(100.dvw)
            .padding(2.cssRem),
        contentAlignment = Alignment.Center
    ) {
        Box(
            Modifier
                .backgroundColor(userPageColor)
                .border {
                    width(1.px)
                    color(userPageBorderStrongColor)
                    style(org.jetbrains.compose.web.css.LineStyle.Solid)
                }
                .borderRadius(1.cssRem)
                .padding(2.cssRem)
                .then(containerShadowStyle.toModifier())
                .fontSize(1.5.cssRem)
                .maxWidth(80.percent)
                .textAlign(TextAlign.Center),
            contentAlignment = Alignment.Center
        ) {
            when (transactionStatus) {
                "PENDING" -> {
                    Column(horizontalAlignment = Alignment.CenterHorizontally, modifier = Modifier.gap(1.cssRem)) {
                        SpanText("Verifying your payment settlement confirmation records with bank portal")
                        SpanText("Please do not close this browser tab or navigate away.")
                    }
                }
                "PAID" -> {
                    Column(horizontalAlignment = Alignment.CenterHorizontally, modifier = Modifier.gap(1.cssRem)) {
                        SpanText("Success! Your payment was verified securely.")
                        SpanText("Your credit ledger has updated and your account balance is active.")
                        Button(
                            onClick = {
                                ctx.router.navigateTo("/user")
                            }
                        ) {
                            SpanText("Back to main page")
                        }
                    }
                }
                "FAILED" -> {
                    Column(horizontalAlignment = Alignment.CenterHorizontally, modifier = Modifier.gap(1.cssRem)) {
                        SpanText("Transaction was declined or cancelled by the bank.")
                        SpanText("No credits were deducted. Please try initiating checkout again.")
                        Button(
                            onClick = {
                                ctx.router.navigateTo("/user")
                            }
                        ) {
                            SpanText("Back to main page")
                        }
                    }
                }
                else -> {
                    Column(horizontalAlignment = Alignment.CenterHorizontally, modifier = Modifier.gap(1.cssRem)) {
                        SpanText("An error occurred checking payment reference state: $transactionStatus")
                        Button(
                            onClick = {
                                ctx.router.navigateTo("/user")
                            }
                        ) {
                            SpanText("Back to main page")
                        }
                    }
                }
            }
        }
    }
}